import { createElement } from 'react';
import cn from 'classnames';
import styles from 'ui-components/Spinner.scss';

var Spinner = function Spinner(_ref) {
  var _cn;
  var className = _ref.className,
    variant = _ref.variant;
  return /*#__PURE__*/createElement("div", {
    className: cn(styles.block, (_cn = {}, _cn[styles[variant]] = variant, _cn), styles[className])
  }, /*#__PURE__*/createElement("div", {
    className: styles.wrap
  }, /*#__PURE__*/createElement("span", {
    className: styles.dot
  }), /*#__PURE__*/createElement("span", {
    className: styles.dot
  }), /*#__PURE__*/createElement("span", {
    className: styles.dot
  }), /*#__PURE__*/createElement("span", {
    className: styles.dot
  }), /*#__PURE__*/createElement("span", {
    className: styles.dot
  })));
};

export { Spinner };
//# sourceMappingURL=index.js.map
